import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { supabase } from "../../supabase";

const MessagesComponent = () => {
  const { t } = useTranslation();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState<any>(null);
  const [messages, setMessages] = useState<any[]>([]);
  const [visits, setVisits] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  const ADMIN_EMAIL = "mohamed.ali.ayedi.b@gmail.com";

  useEffect(() => {
    const checkUser = async () => {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      if (session?.user) {
        if (session.user.email === ADMIN_EMAIL) {
          setIsAuthenticated(true);
          setUser(session.user);
        } else {
          await supabase.auth.signOut();
        }
      }
      setLoading(false);
    };

    checkUser();

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      if (session?.user && session.user.email === ADMIN_EMAIL) {
        setIsAuthenticated(true);
        setUser(session.user);
      } else {
        setIsAuthenticated(false);
        setUser(null);
      }
    });

    return () => subscription.unsubscribe();
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      fetchMessages();
      fetchVisits();
    }
  }, [isAuthenticated]);

  const fetchMessages = async () => {
    const { data, error } = await supabase
      .from("messages")
      .select("*")
      .order("created_at", { ascending: false });

    if (!error) setMessages(data || []);
  };

  const fetchVisits = async () => {
    const { data, error } = await supabase
      .from("visits")
      .select("*")
      .order("created_at", { ascending: false });

    if (!error) setVisits(data || []);
  };

  const handleGitHubLogin = async () => {
    const { error } = await supabase.auth.signInWithOAuth({
      provider: "github",
      options: { redirectTo: window.location.href },
    });
    if (error) alert(error.message);
  };

  const handleLogout = async () => {
    await supabase.auth.signOut();
    setIsAuthenticated(false);
    setUser(null);
  };

  if (loading && !isAuthenticated) {
    return (
      <article className="contact active">
        <div className="container-loader">
          <div className="loader">
            <svg className="circular" viewBox="25 25 50 50">
              <circle
                className="path"
                cx="50"
                cy="50"
                r="20"
                fill="none"
                strokeWidth="2"
                strokeMiterlimit="10"
              />
            </svg>
          </div>
        </div>
      </article>
    );
  }

  if (!isAuthenticated) {
    return (
      <article className="contact active" data-page="admin-login">
        <header>
          <h2 className="h2 article-title">Internal Security</h2>
        </header>
        <section
          className="contact-form"
          style={{ textAlign: "center", padding: "40px 20px" }}
        >
          <div
            className="icon-box"
            style={{
              margin: "0 auto 30px",
              width: "100px",
              height: "100px",
              background: "var(--item-gradient)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "24px",
              boxShadow: "var(--shadow-1)",
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="48"
              fill="var(--accent-primary)"
              viewBox="0 0 16 16"
            >
              <path d="M11 1a2 2 0 0 0-2 2v4a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h5V3a3 3 0 0 1 6 0v4a.5.5 0 0 1-1 0V3a2 2 0 0 0-2-2zM8.5 7V3a1.5 1.5 0 1 0-3 0v4h3z" />
            </svg>
          </div>
          <h3 className="h3" style={{ marginBottom: "15px" }}>
            Principal Architect Login
          </h3>
          <p
            className="form-funny-note"
            style={{
              maxWidth: "400px",
              margin: "0 auto 40px",
              lineHeight: "1.6",
            }}
          >
            Identify yourself as the master of this domain. Use your synced
            GitHub account to unlock the control center.
          </p>
          <button
            className="form-btn"
            onClick={handleGitHubLogin}
            style={{ margin: "0 auto", padding: "12px 30px" }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              viewBox="0 0 16 16"
              style={{ marginRight: "10px" }}
            >
              <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.012 8.012 0 0 0 16 8c0-4.42-3.58-8-8-8z" />
            </svg>
            <span>Decrypt Access via GitHub</span>
          </button>
        </section>
      </article>
    );
  }

  // Activity stats
  const messagesToday = messages.filter(
    (m) => new Date(m.created_at) > new Date(Date.now() - 24 * 60 * 60 * 1000)
  ).length;

  return (
    <article className="contact active" data-page="messages">
      <header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "baseline",
          marginBottom: "30px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
          <div style={{ position: "relative" }}>
            <img
              src={user.user_metadata.avatar_url}
              alt="Admin"
              style={{
                width: "55px",
                height: "55px",
                borderRadius: "18px",
                border: "2px solid var(--accent-primary)",
                padding: "1px",
              }}
            />
            <div
              style={{
                position: "absolute",
                bottom: "-4px",
                right: "-4px",
                width: "14px",
                height: "14px",
                background: "#10b981",
                borderRadius: "50%",
                border: "2px solid var(--bg-card)",
              }}
            ></div>
          </div>
          <div>
            <h2 className="h2 article-title" style={{ margin: 0 }}>
              Command Center
            </h2>
            <p
              style={{
                fontSize: "12px",
                color: "var(--text-muted)",
                marginTop: "2px",
              }}
            >
              Greetings, {user.user_metadata.full_name}
            </p>
          </div>
        </div>
        <button
          onClick={handleLogout}
          style={{
            color: "var(--accent-primary)",
            fontSize: "11px",
            fontWeight: "700",
            textTransform: "uppercase",
            letterSpacing: "1.5px",
            padding: "6px 12px",
            borderRadius: "10px",
            background: "rgba(56, 189, 248, 0.05)",
            border: "1px solid rgba(56, 189, 248, 0.15)",
          }}
        >
          Sign Out
        </button>
      </header>

      {/* Stats Cards */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
          gap: "20px",
          marginBottom: "40px",
        }}
      >
        {[
          {
            label: "Client Inquiries",
            value: messages.length,
            color: "var(--accent-primary)",
            icon: "envelope",
          },
          {
            label: "Total Site Visits",
            value: visits.length,
            color: "#a855f7",
            icon: "eye",
          },
          {
            label: "Activity (24h)",
            value: messagesToday,
            color: "#10b981",
            icon: "activity",
          },
        ].map((stat, i) => (
          <div
            key={i}
            style={{
              background: "var(--item-gradient)",
              padding: "20px",
              borderRadius: "20px",
              border: "1px solid var(--item-rgb)",
              boxShadow: "var(--shadow-1)",
              display: "flex",
              flexDirection: "column",
              gap: "8px",
            }}
          >
            <p
              style={{
                fontSize: "11px",
                fontWeight: "600",
                textTransform: "uppercase",
                color: "var(--text-muted)",
                letterSpacing: "0.5px",
              }}
            >
              {stat.label}
            </p>
            <p
              style={{
                fontSize: "28px",
                fontWeight: "700",
                color: stat.color,
                margin: 0,
              }}
            >
              {stat.value}
            </p>
          </div>
        ))}
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: "40px" }}>
        {/* Messages Card */}
        <section
          style={{
            background: "var(--bg-card)",
            border: "1px solid var(--item-rgb)",
            borderRadius: "25px",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              padding: "20px 25px",
              borderBottom: "1px solid var(--item-rgb)",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h3 className="h3" style={{ margin: 0, fontSize: "17px" }}>
              Latest Inquiries
            </h3>
            <span
              style={{
                fontSize: "10px",
                background: "rgba(56, 189, 248, 0.1)",
                color: "var(--accent-primary)",
                padding: "4px 10px",
                borderRadius: "20px",
                fontWeight: "700",
              }}
            >
              MANAGED
            </span>
          </div>
          <div style={{ padding: "10px 0" }}>
            {messages.length === 0 ? (
              <p
                style={{
                  padding: "40px",
                  color: "var(--text-secondary)",
                  textAlign: "center",
                  fontSize: "14px",
                }}
              >
                No communication records found.
              </p>
            ) : (
              messages.map((msg, index) => (
                <div
                  key={index}
                  style={{
                    padding: "20px 25px",
                    borderBottom:
                      index === messages.length - 1
                        ? "none"
                        : "1px solid rgba(255, 255, 255, 0.05)",
                    transition: "0.2s",
                  }}
                  className="dashboard-item"
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                      marginBottom: "8px",
                    }}
                  >
                    <h4
                      className="h4"
                      style={{
                        margin: 0,
                        color: "var(--accent-primary)",
                        fontSize: "15px",
                      }}
                    >
                      {msg.fullname}
                    </h4>
                    <span
                      style={{
                        fontSize: "10px",
                        color: "var(--text-muted)",
                        fontWeight: "500",
                      }}
                    >
                      {new Date(msg.created_at).toLocaleDateString()}
                    </span>
                  </div>
                  <p
                    style={{
                      fontSize: "11px",
                      display: "inline-block",
                      padding: "2px 8px",
                      borderRadius: "6px",
                      background: "rgba(255,255,255,0.03)",
                      color: "var(--text-muted)",
                      marginBottom: "12px",
                    }}
                  >
                    {msg.email}
                  </p>
                  <p
                    className="timeline-text"
                    style={{
                      fontSize: "13px",
                      margin: 0,
                      lineHeight: "1.6",
                      color: "var(--text-secondary)",
                    }}
                  >
                    {msg.message}
                  </p>
                </div>
              ))
            )}
          </div>
        </section>

        {/* Traffic Card */}
        <section
          style={{
            background: "var(--bg-card)",
            border: "1px solid var(--item-rgb)",
            borderRadius: "25px",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              padding: "20px 25px",
              borderBottom: "1px solid var(--item-rgb)",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h3 className="h3" style={{ margin: 0, fontSize: "17px" }}>
              Site Traffic
            </h3>
            <span
              style={{
                fontSize: "10px",
                background: "rgba(168, 85, 247, 0.1)",
                color: "#a855f7",
                padding: "4px 10px",
                borderRadius: "20px",
                fontWeight: "700",
              }}
            >
              REAL-TIME
            </span>
          </div>
          <div style={{ padding: "0" }}>
            {visits.length === 0 ? (
              <p
                style={{
                  padding: "40px",
                  color: "var(--text-secondary)",
                  textAlign: "center",
                  fontSize: "14px",
                }}
              >
                No traffic recorded.
              </p>
            ) : (
              <div style={{ maxHeight: "350px", overflowY: "auto" }}>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead
                    style={{
                      position: "sticky",
                      top: 0,
                      background: "var(--bg-card)",
                      zIndex: 1,
                      boxShadow: "0 1px 0 var(--item-rgb)",
                    }}
                  >
                    <tr>
                      <th
                        style={{
                          textAlign: "left",
                          padding: "12px 25px",
                          fontSize: "11px",
                          color: "var(--text-muted)",
                          fontWeight: "600",
                          textTransform: "uppercase",
                        }}
                      >
                        IP Address
                      </th>
                      <th
                        style={{
                          textAlign: "right",
                          padding: "12px 25px",
                          fontSize: "11px",
                          color: "var(--text-muted)",
                          fontWeight: "600",
                          textTransform: "uppercase",
                        }}
                      >
                        Last Seen
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {visits.slice(0, 15).map((visit, index) => (
                      <tr
                        key={index}
                        style={{
                          borderBottom: "1px solid rgba(255, 255, 255, 0.02)",
                        }}
                      >
                        <td
                          style={{
                            padding: "15px 25px",
                            fontSize: "13px",
                            color: "var(--text-secondary)",
                            fontFamily: "monospace",
                          }}
                        >
                          {visit.ip_address}
                        </td>
                        <td
                          style={{
                            padding: "15px 25px",
                            fontSize: "12px",
                            color: "var(--text-muted)",
                            textAlign: "right",
                          }}
                        >
                          {new Date(visit.created_at).toLocaleTimeString([], {
                            hour: "2-digit",
                            minute: "2-digit",
                            day: "2-digit",
                            month: "short",
                          })}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </section>
      </div>

      {/* Control Actions */}
      <div style={{ display: "flex", gap: "15px", marginTop: "50px" }}>
        <button
          className="form-btn"
          style={{
            flex: 1,
            height: "48px",
            background: "rgba(239, 68, 68, 0.08)",
            color: "#ef4444",
            border: "1px solid rgba(239, 68, 68, 0.2)",
            borderRadius: "14px",
            fontWeight: "700",
            fontSize: "12px",
            textTransform: "uppercase",
            letterSpacing: "1px",
          }}
          onClick={async () => {
            if (window.confirm("CRITICAL: Wipe all message history?")) {
              const { error } = await supabase
                .from("messages")
                .delete()
                .neq("id", 0);
              if (!error) setMessages([]);
            }
          }}
        >
          Purge Inquiries
        </button>

        <button
          className="form-btn"
          style={{
            flex: 1,
            height: "48px",
            background: "rgba(113, 113, 122, 0.08)",
            color: "var(--text-secondary)",
            border: "1px solid var(--item-rgb)",
            borderRadius: "14px",
            fontWeight: "700",
            fontSize: "12px",
            textTransform: "uppercase",
            letterSpacing: "1px",
          }}
          onClick={async () => {
            if (window.confirm("Reset all visitor analytics data?")) {
              const { error } = await supabase
                .from("visits")
                .delete()
                .neq("id", 0);
              if (!error) setVisits([]);
            }
          }}
        >
          Reset Logs
        </button>
      </div>
    </article>
  );
};

export default MessagesComponent;
